var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFirstPlaceBadgeWhite = function SvgFirstPlaceBadgeWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C21.7279 21.5 24.75 18.5899 24.75 15C24.75 11.4101 21.7279 8.5 18 8.5C14.2721 8.5 11.25 11.4101 11.25 15C11.25 18.5899 14.2721 21.5 18 21.5Z",
    stroke: "#FB7B04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5197 20.0198L13.5098 27.3998C13.5098 28.2998 14.1398 28.7398 14.9198 28.3698L17.5998 27.0999C17.8198 26.9899 18.1898 26.9899 18.4098 27.0999L21.0998 28.3698C21.8698 28.7298 22.5098 28.2998 22.5098 27.3998V19.8398",
    stroke: "#FB7B04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5485 12.5V11.21H18.9585V18.5H17.5185V12.5H16.5485Z",
    fill: "#FB7B04"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFirstPlaceBadgeWhite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOCAyMS41QzIxLjcyNzkgMjEuNSAyNC43NSAxOC41ODk5IDI0Ljc1IDE1QzI0Ljc1IDExLjQxMDEgMjEuNzI3OSA4LjUgMTggOC41QzE0LjI3MjEgOC41IDExLjI1IDExLjQxMDEgMTEuMjUgMTVDMTEuMjUgMTguNTg5OSAxNC4yNzIxIDIxLjUgMTggMjEuNVoiIHN0cm9rZT0iI0ZCN0IwNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuNTE5NyAyMC4wMTk4TDEzLjUwOTggMjcuMzk5OEMxMy41MDk4IDI4LjI5OTggMTQuMTM5OCAyOC43Mzk4IDE0LjkxOTggMjguMzY5OEwxNy41OTk4IDI3LjA5OTlDMTcuODE5OCAyNi45ODk5IDE4LjE4OTggMjYuOTg5OSAxOC40MDk4IDI3LjA5OTlMMjEuMDk5OCAyOC4zNjk4QzIxLjg2OTggMjguNzI5OCAyMi41MDk4IDI4LjI5OTggMjIuNTA5OCAyNy4zOTk4VjE5LjgzOTgiIHN0cm9rZT0iI0ZCN0IwNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuNTQ4NSAxMi41VjExLjIxSDE4Ljk1ODVWMTguNUgxNy41MTg1VjEyLjVIMTYuNTQ4NVoiIGZpbGw9IiNGQjdCMDQiLz4KPC9zdmc+Cg==";